import * as actions from "./assets.actions";
import * as api from "./assets.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./assets.constants";
import * as hooks from "./assets.hooks";
import * as promises from "./assets.promises";
import reducer from "./assets.reducer";
import { saga } from "./assets.saga";
import * as selectors from "./assets.selectors";
export var REDUCER_KEY_ASSETS = REDUCER_KEY;
export var assetsModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
